// src/components/EventMenuComponent.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

import {
    IconCalendarEvent,
    IconMapPin,
} from '@tabler/icons-react';

import './MenuComponent.css';


/* =========================================
   TYPES
   ========================================= */

interface EventMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    icon: React.ReactNode;
    link: string;
}

interface EventMenuProps {
    eventID?: number;
    itemsToShow?: number[];
}


/* =========================================
   MENU ITEMS
   ========================================= */

const defaultEventMenuItems: EventMenuItem[] = [
    {
        id: 1,
        titleEn: 'Manage Event',
        titleDa: 'Administrér Event',
        icon: <IconCalendarEvent />,
        link: '/event/event',
    },
    {
        id: 2,
        titleEn: 'Zones',
        titleDa: 'Zoner',
        icon: <IconMapPin />,
        link: '/event/zones',
    },
];


/* =========================================
   COMPONENT
   ========================================= */

const EventMenuComponent: React.FC<EventMenuProps> = ({
    eventID,
    itemsToShow,
}) => {

    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultEventMenuItems.filter((item) =>
            itemsToShow.includes(item.id)
        )
        : defaultEventMenuItems;


    return (
        <div className="menu-container">

            <section className="menu-section">

                <div className="menu-section-header">

                    <h2 className="menu-section-title">
                        {language === 'da'
                            ? 'Event administration'
                            : 'Event Administration'}
                    </h2>

                    <span className="menu-section-count">
                        {filteredMenuItems.length}
                    </span>

                </div>


                <div className="menu-grid">

                    {filteredMenuItems.map((item) => {

                        const title =
                            language === 'da'
                                ? item.titleDa
                                : item.titleEn;

                        const link = eventID
                            ? `${item.link}/${eventID}`
                            : item.link;


                        return (
                            <Link
                                key={item.id}
                                to={link}
                                className="menu-card"
                            >

                                <div className="menu-card-content">

                                    <div className="menu-icon">
                                        {item.icon}
                                    </div>

                                    <div className="menu-card-text">

                                        <div className="menu-title">
                                            {title}
                                        </div>

                                    </div>

                                </div>

                            </Link>
                        );
                    })}

                </div>

            </section>

        </div>
    );
};

export default EventMenuComponent;